export default "__VITE_ASSET__DMNSG7Ju__"